import { z } from 'zod';
import { nullableUuidString, requiredUuidString } from '../zod-helpers/index.js';
// One Default-BOM-For entry nested inside CreateBomInput.defaultForParts — mirrors addBomDefaultPartInputSchema minus bomId.
export const createDefaultPartInputSchema = z.object({
    partId: requiredUuidString('Part is required.', 'Invalid part selection.'),
    confirmedAgainstBomId: nullableUuidString('Invalid BOM confirmation.').optional(),
});
//# sourceMappingURL=create-default-part-input.js.map